import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { HStack, VStack } from 'naan/primitives/stack';
import { VSpacer } from 'naan/primitives/spacer';
import { Link } from 'naan/primitives/text';
import __ from 'core/lib/localization';
import { AppFactory } from '@app/app-factory';
import { closeAccountPath } from 'components/nav/path-helpers';

export const CloseAccountLink = () => {
  const { membershipState } = AppFactory.root.userManager;

  if (membershipState !== 'trial') {
    return null;
  }
  return (
    <VStack>
      <VSpacer size={4} />
      <HStack justify="end">
        <Link
          as={RouterLink}
          destructive
          to={closeAccountPath()}
          className="account__close-account-link"
        >
          {__('Close account', 'closeAccount')}
        </Link>
      </HStack>
      <VSpacer size={4} />
    </VStack>
  );
};
